import { useEffect, useState } from "react";
import React from "react";
import { Card, Row, Col } from "antd";
import { fetchArticleDetails } from "api/articleservice";
import ArticleFiles from "./ArticleFiles";
import "../css/ArticleDetailsCard.css"; // اضافه کردن فایل CSS سفارشی

const ArticleDetailsCard = ({ activeTabKey, articleId }) => {
  const [article, setArticle] = useState({});

  function stripHtml(html) 
  {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value.replace(/<[^>]+>/g, '');
  }

  useEffect(() => {
    if (!articleId) return;

    fetchArticleDetails(articleId)
      .then((data) => {
        setArticle(data || {});
      })
      .catch((err) => console.error("Error fetching article:", err));
  }, [articleId]);

  if (activeTabKey === "1") {
    const attributes = [
      { key: "title", label: "Title" },
      { key: "code", label: "Code" },
      // { key: "author", label: "Author" },
      { key: "authorS", label: "Authors" },      
      { key: "fundingS", label: "Fundings" },  
      { key: "contributions", label: "Contributions" },  
      { key: "abstract", label: "Abstract" },
      { key: "keywords", label: "Keywords" },
      { key: "createdDate", label: "Created Date" },

      
    ];

    return (
      <Card key="details" title="📄 Article Details" className="details-card">
        <Row gutter={[16, 16]}>
          {attributes.map(({ key, label }) => (
            <Col span={24} key={key}>
              <div className="attribute">
                <strong>{label}:</strong>{" "}
                {Array.isArray(article[key]) && key === "authorS" ? (
                  article[key].length > 0 ? (
                  <ul style={{ paddingLeft: "1.5rem", margin: "0.25rem 0" }}>
                    {article[key].map((item, idx) => (
                      <li key={idx} style={{ marginBottom: "4px" }}>
                        {item.firstName && item.lastName && item.email
                          ? `${idx + 1}. ${item.firstName} ${item.lastName} -  ${item.email} - ${item.isCorresponding ? 'Corresponding -' : ''} ( ${ item.primaryAffiliation } )`
                          : "Invalid data"}
                      </li>
                    ))}
                  </ul>
                  ) : (
                    "No Data"
                  )
                ) : Array.isArray(article[key]) && key === "fundingS" ? (
                  article[key].length > 0 ? (
                  <ul style={{ paddingLeft: "1.5rem", margin: "0.25rem 0" }}>
                    {article[key].map((item, idx) => (
                      <li key={idx} style={{ marginBottom: "4px" }}>
                        {item.funderName
                          ? `${item.funderName}`
                          : "Invalid data"}
                      </li>
                    ))}
                  </ul>
                  ) : (
                    "No Data"
                  )
                ) : key === "title" || key === "abstract" ? (
                  article[key] ? stripHtml(article[key]) : "No Data"
                ) : 
                  key === "title" || key === "abstract" ? (
                    article[key] ? stripHtml(article[key]) : "No Data"
                ): 
                
                key === "createdDate" ? (
                  article[key]
                  ? new Date(article[key]).toISOString().split("T")[0]
                  : "No Data"
                ): 



                (
                  article[key] || "No Data"
                )}
              </div>
            </Col>
          ))}

        </Row>
      </Card>
    );
  }

  if (activeTabKey === "2") {
    return (
      <Card key="article files" title="🗃️ Article Files" className="files-card">
        <ArticleFiles articleData={article}  />
      </Card>
    );
  }

  return null;
};

export default ArticleDetailsCard;
